import { loadingWindows } from '@constants/orderDispatch'
import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react'
import { TimeSpanFilter } from '../TimeSpan/TimeSpan'
import { doesLoadingWindowPass } from './util'

type LoadingWindowFilterProps = {
  accessor: string
  accessor2?: string
  colDef?: any
  filterChangedCallback: () => void
}

export default forwardRef<unknown, LoadingWindowFilterProps>((props, ref) => {
  const [selectedOptions, setSelectedOptions] = useState('')
  const buttons = [
    { text: 'Now', value: loadingWindows.NOW, className: 'mt-4 ml-3 mr-3' },
    { text: 'Before 6PM', value: loadingWindows.BEFORESIX, className: 'mt-3 ml-3 mr-3' },
    { text: 'Before Midnight', value: loadingWindows.BEFOREMIDNIGHT, className: 'mt-3 ml-3 mr-3' },
    { text: 'After Midnight', value: loadingWindows.AFTERMIDNIGHT, className: 'pt-3 pl-3 pr-3 pb-4 bottom-border' },
  ]
  useImperativeHandle(ref, () => {
    return {
      doesFilterPass(params) {
        const accessors = props.accessor2
          ? [
              params.data?.[props.accessor]?.[props.accessor2]?.load_window_start,
              params.data?.[props.accessor]?.[props.accessor2]?.load_window_end,
            ]
          : props?.colDef?.headerName === 'Delivery Window'
            ? [params.data.delivery_window_start, params.data.delivery_window_end]
            : [params.data.load_window_start, params.data.load_window_end]
        const loadWindowPasses = doesLoadingWindowPass(accessors[0], accessors[1], selectedOptions)
        return loadWindowPasses
      },
      isFilterActive() {
        return !!selectedOptions
      },
    }
  })

  useEffect(() => {
    props.filterChangedCallback()
  }, [selectedOptions])

  const onClick = (value) => {
    if (selectedOptions && selectedOptions.includes(value)) {
      setSelectedOptions('')
    } else {
      setSelectedOptions(value)
    }
  }

  const onClear = () => {
    setSelectedOptions(null)
  }

  return (
    <TimeSpanFilter
      property='loadingWindow'
      buttons={buttons}
      onClick={onClick}
      onClear={onClear}
      selectedOptions={selectedOptions}
    />
  )
})
